import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { filter, fromEvent, map, Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { ComponentStore } from '@ngrx/component-store';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[i2lDrupalRichTextLink]',
  standalone: true,
})
export class DrupalRichTextLinkDirective
  extends ComponentStore<any>
  implements OnInit
{
  el = inject(ElementRef<HTMLElement>);
  router = inject(Router);
  document = inject(DOCUMENT);

  onClick = this.effect((clickEvent$: Observable<MouseEvent>) => {
    return clickEvent$.pipe(
      filter((clickEvent: MouseEvent) => {
        return (clickEvent.target as HTMLElement).tagName === 'A';
      }),
      tap((clickEvent: MouseEvent) => {
        clickEvent.preventDefault();
      }),
      map((clickEvent: MouseEvent) => {
        return clickEvent.target as HTMLLinkElement;
      }),
      tap((target: HTMLLinkElement) => {
        const url = target.getAttribute('href');
        const isInternalLink = url?.indexOf('http') === -1;
        if (url) {
          if (isInternalLink) {
            this.router.navigateByUrl(url);
          } else {
            if (this.document.defaultView) {
              this.document.defaultView.open(url, '_blank');
            }
          }
        }
      })
    );
  });

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.onClick(fromEvent<MouseEvent>(this.el.nativeElement, 'click'));
  }
}
